<template>
    <notifications v-bind="config"></notifications>
</template>

<script>
    import Notifications1 from 'vue-notification'
    //1 added to solve conflict internally with name
    Vue.use(Notifications1)
    // https://github.com/euvl/vue-notification/blob/master/README.md

    import { EventBus } from 'Js/eventBus';
    export default {

        name: 'toaster',

        components: {
            Notifications1
        },

        methods: {
            showToaster: function(params) {
                this.config = Object.assign({}, this.defaults, params, params.options);
                this.$notify(this.config)
            }
        },
        created() {},

        mounted() {
            EventBus.$on('toaster', params => {
                this.showToaster(params)
            })
        },

        data() {
            return {
                config: {
                    group: 'main', // needed for reactivity
                },
                defaults: {
                    group: 'main',
                    position: 'top center',
                    title: "SetTitle",
                    position: "top center",
                    type: 'warning',
                    text: 'You haven\'t <b> Configured your content</b>',
                    duration: 3000,
                }
            }
        }
    }
</script>
